import { render, staticRenderFns } from "./AddCowModal.vue?vue&type=template&id=08dc3392&"
import script from "./AddCowModal.vue?vue&type=script&lang=js&"
export * from "./AddCowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports